module.exports = __webpack_public_path__ + "img/GroupN9.cb0935df.png";